import { render, staticRenderFns } from "./CorrectiveSamplesForm.vue?vue&type=template&id=9517ce6c&scoped=true&lang=pug&"
import script from "./CorrectiveSamplesForm.vue?vue&type=script&lang=js&"
export * from "./CorrectiveSamplesForm.vue?vue&type=script&lang=js&"
import style0 from "./CorrectiveSamplesForm.vue?vue&type=style&index=0&id=9517ce6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9517ce6c",
  null
  
)

export default component.exports